import React from 'react';
import { Rule } from 'src/helpers/rulesEngine';
import { Link } from 'src/components/Analytics';
import Alert from 'src/components/Alert/';
import { isActive } from 'src/helpers/page';

const UnverifiedAddressAlert: Rule<JSX.Element> = state => {
  const { verificationStatus, status, name } = state.page;
  const alertKey = 'verify_address';

  if (isActive({ status }) && verificationStatus === 'UnverifiedAddress') {
    return {
      matched: true,
      result: (
        <Alert id={alertKey} type="red" persistent>
          <p className="jg-space-mbn">
            Oops! Something went wrong with the document you provided. We will
            need to send you a letter to your address to get you verified so
            please{' '}
            <Link to={`/${name}/dashboard/address`}>
              confirm your address here
            </Link>
            . Don’t worry, you can still receive donations in the meantime.
          </p>
        </Alert>
      ),
    };
  }

  return { matched: false };
};

export default UnverifiedAddressAlert;



// WEBPACK FOOTER //
// ./src/helpers/alerts/UnverifiedAddressAlert.tsx